// 面のクリアの直後、クリアの画面を出す前に見せる大爆発(2026-11-05 オーナー要望「ボスを撃墜した瞬間に消えてしまうのを、大爆発まで見せてから」)。
// 見た目だけ。試合の計算(src/sim/)はクリアで止めたまま、その最後の形を写しながら、作り物の「倒した」出来事を時間をずらして流す。
// 流れ: 残っている小さな敵が次々に爆発 → 倒した大物のまわりで連鎖爆発 → 真ん中で一番大きな爆発 → 煙が引いたらクリアの画面へ(main.js)
import { config } from "../config.js";

// world: クリアした瞬間の試合。boss: 少し前に倒した大物の「倒した」出来事(無ければ null。時間でクリアしたときなど)
// 返す物: { events: 時刻(at 秒)の順の作り物の出来事, seconds: クリアの画面までの秒 }
export function planFinale(world, boss) {
  const F = config.juice.finale;
  const events = [];
  // 残っている小さな敵(撤退中の母艦など大物は、倒していないのでそのまま)
  const T = config.enemies.types;
  const small = world.enemies.filter((e) => e.hp > 0 && !T[e.type].big).slice(0, F.maxSmall);
  for (const e of small) {
    events.push({ at: F.smallFrom + Math.random() * (F.smallTo - F.smallFrom), k: "kill", id: e.id, x: e.x, y: e.y, z: e.z, type: e.type, big: false, size: e.size });
  }
  if (boss) {
    const r = (T[boss.type] ? T[boss.type].radius : 30) * boss.size;
    for (let i = 0; i < F.chain; i++) {
      // 大物の体の上の、ばらばらの所(球の中)
      const u = Math.random() * 2 - 1;
      const a = Math.random() * Math.PI * 2;
      const d = r * (0.35 + Math.random() * 0.55);
      const s = Math.sqrt(1 - u * u) * d;
      const at = F.chainFrom + ((i + Math.random() * 0.6) / F.chain) * (F.megaAt - F.chainFrom);
      events.push({ at, k: "kill", x: boss.x + Math.cos(a) * s, y: boss.y + u * d, z: boss.z + Math.sin(a) * s, type: boss.type, big: true, chain: true, size: boss.size * F.chainSize });
    }
    events.push({ at: F.megaAt, k: "kill", x: boss.x, y: boss.y, z: boss.z, type: boss.type, big: true, size: boss.size * F.megaSize, mega: true });
  }
  events.sort((a, b) => a.at - b.at);
  return { events, seconds: boss ? F.seconds : F.secondsNoBoss };
}

// 大爆発の間に描く試合: 敵の弾・自分の弾は消し(止まった弾が宙に浮いて見えないように)、爆発した敵は外す。元の world は変えない
export function finaleView(world, gone) {
  return {
    ...world,
    shots: [],
    enemyShots: [],
    enemies: world.enemies.filter((e) => !gone.has(e.id)),
    player: { ...world.player, mainGunFiring: 0, invuln: 0 },
  };
}
